import React from "react";
import { useTranslation } from "@/context/LanguageContext";

interface RoomTypingIndicatorProps {
  typingUsers: { user_id: string; name: string }[];
}

export const RoomTypingIndicator: React.FC<RoomTypingIndicatorProps> = ({
  typingUsers,
}) => {
  const { t } = useTranslation();
  const visible = typingUsers.length > 0;

  let label = "";
  if (typingUsers.length === 1) {
    label =
      (t("room.typing.single") || "{name} is typing…").replace(
        "{name}",
        typingUsers[0].name,
      );
  } else if (typingUsers.length === 2) {
    label = (t("room.typing.multiple") || "{name1} and {name2} are typing…")
      .replace("{name1}", typingUsers[0].name)
      .replace("{name2}", typingUsers[1].name);
  } else if (typingUsers.length > 2) {
    label = t("room.typing.many") || "Several people are typing…";
  }

  return (
    <div
      className={`h-6 px-3 transition-opacity duration-150 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
      aria-live="polite"
    >
      {visible && (
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <span className="inline-flex items-end gap-0.5">
            <span className="h-1 w-1 animate-bounce rounded-full bg-muted-foreground [animation-delay:-0.3s]" />
            <span className="h-1 w-1 animate-bounce rounded-full bg-muted-foreground [animation-delay:-0.15s]" />
            <span className="h-1 w-1 animate-bounce rounded-full bg-muted-foreground" />
          </span>
          <span className="truncate">{label}</span>
        </div>
      )}
    </div>
  );
};
